
export default {
	SERVER_BASE: "https://grenstall.shop4sale.se/branchstand_server/",
	API_URL: "https://kalls.se/headless/"
}